import React from 'react'
import PropTypes from 'prop-types'

const EmptyEditor = props => <div className={props.className}></div>

EmptyEditor.propTypes = {
  className: PropTypes.string
}

export default EmptyEditor
